import { type ResultError } from '../../providers/as-data-provider';
import { errorToReason } from '../error-to-reason';

export enum SwitcherLoadErrorReason {
	AVAILABLE_PRODUCTS = 'availableProducts',
	PRODUCT_CONFIGURATION = 'productConfiguration',
	THIRD_PARTY_CONFIG = 'thirdPartyConfig',
}

export class SwitcherLoadError extends Error {
	readonly errorReason: SwitcherLoadErrorReason;
	readonly resultError: ResultError | Error;

	constructor(errorReason: SwitcherLoadErrorReason, resultError: ResultError | Error) {
		super();
		this.errorReason = errorReason;
		this.resultError = resultError;
	}

	public reason(): {
		name: string;
		source: SwitcherLoadErrorReason;
		status?: number;
	} {
		const potentialResultError = this.resultError as ResultError;
		return {
			...errorToReason(potentialResultError.error ? potentialResultError.error : this.resultError),
			source: this.errorReason,
		};
	}
}
